<template>
  <div class="c-m-30 c-p-24 c-b-r-16 bg-white">
    <div class="c-f-bt">
      <p class="c-ft-30">{{ vpnInfo.Name }}</p>
      <p class="c-ft-24">
        营业时间：{{ vpnInfo.BusinessStartTime }}-{{ vpnInfo.BusinessEndTime }}
      </p>
    </div>
    <div class="c-f-bt c-m-tb-20" @click="phone(vpnInfo)">
      <div class="c-ft-24">
        <p class="c-sub-txt c-m-b-10">电话</p>
        <p>{{ vpnInfo.Phone }}</p>
      </div>
      <div>
        <img src="@/assets/svg/phone.svg" alt="" class="c-w-35" />
      </div>
    </div>
    <div class="c-f-bt c-m-tb-20" @click="toAddress(vpnInfo)">
      <div class="c-ft-24">
        <p class="c-sub-txt c-m-b-10">门店地址</p>
        <p>{{ vpnInfo.Address }}</p>
      </div>
      <div>
        <img src="@/assets/svg/address.svg" alt="" class="c-w-35" />
      </div>
    </div>
    <!-- <div class="content-r">
        <div class="life-item c-fl-bt">
          <div class="title f-1">{{ vpnInfo.Name }}</div>
          <div class="detail c-tc c-fl" @click="detail(vpnInfo)">
            详情
            <g-arrow class="c-m-l-5" :width="14" :color="'var(--tc)'"></g-arrow>
          </div>
        </div>
        <div class="phone-item c-fl-bt" @click="phone(vpnInfo)">
          <div class="c-fl">
            <g-img
              :size="20"
              :src="require('@/assets/images/ticketPhone.png')"
              alt=""
            />
            <span class="c-p-l-20">{{ vpnInfo.Phone }}</span>
          </div>
          <div>
            <g-arrow :width="14"></g-arrow>
          </div>
        </div>
        <div class="addr-item c-fl-bt" @click="toAddress(vpnInfo)">
          <div class="c-fl">
            <g-img
              :size="20"
              :src="require('@/assets/images/ticketAddress.png')"
              alt=""
            />
            <span class="ellipis c-p-l-20">{{ vpnInfo.Address }}</span>
          </div>
          <div>
            <g-arrow :width="14"></g-arrow>
          </div>
        </div>
      </div> -->
    <!-- <g-line></g-line> -->
  </div>
</template>

<script>
import wxConfig from "@/utils/wxConfig.js";
import { handleLocalStorage } from "@/utils/index";
export default {
  name: "DoorInfo",
  props: {
    vpnId: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      vpnInfo: {},
      allVpnList: [],
    };
  },
  watch: {
    "$store.state.vpnId"(val) {
      console.log("门店id改变为============" + val);
      const vpnItem = this.allVpnList.find((v) => {
        return v.Id === val;
      });
      this.vpnInfo = vpnItem;
    },
  },
  created() {
    this.init();
  },
  mounted() {},
  methods: {
    phone(item) {
      console.log(`22222<<<  item  >>>22222`);
      console.log(item);
      $pub.toTel(item.Phone);
    },
    init() {
      const _this = this;
      if (localStorage.getItem("allStoreList")) {
        handleSetVpn();
      } else {
        window.addEventListener("setItem", () => {
          handleSetVpn();
          // $http(`wechath5/zh-cn/v1/vpn`).then((res) => {
          //   const vpnDatas = res.Items;
          //   this.allVpnList = vpnDatas;
          //   this.resetSetItem("websocketHistory", JSON.stringify(res.Items));
          //   let getVpnId = this.$store.state.vpnId;
          //   const vpnItem = vpnDatas.find((v) => {
          //     return v.Id === getVpnId;
          //   });
          //   if (getVpnId && vpnItem) {
          //     this.vpnInfo = vpnItem;
          //   } else {
          //     this.vpnInfo = vpnDatas[0];
          //   }
          // });
        });
      }
      function handleSetVpn() {
        _this.allVpnList = JSON.parse(localStorage.getItem("allStoreList"));
        let getVpnId = _this.$store.state.vpnId;
        const vpnItem = _this.allVpnList.find((v) => {
          return v.Id === getVpnId;
        });
        if (getVpnId && vpnItem) {
          _this.vpnInfo = vpnItem;
        } else {
          _this.vpnInfo = _this.allVpnList[0];
        }
      }
    },

    detail(v) {
      this.$router.push({
        name: "DoorDetail",
        query: { id: v.Id },
      });
    },
    toAddress(v) {
      if (v.Latitude && v.Longitude && v.Name && v.Address) {
        wxConfig.consultMap(this, v.Latitude, v.Longitude, v.Name, v.Address);
      } else {
        console.log(v.Latitude, v.Longitude, v.Name, v.Address);
        this.$toast("请在后台完善经纬度等信息");
      }
    },
  },
};
</script>
<style scoped lang="scss">
// .box {
//   padding: 20px 17px;
//   margin: 17px 17px 0 17px;
// }
// .content {
//   height: 156px;
//   background: #fff;
//   background: #ffffff;
//   box-shadow: 0px 0px 3px 0px rgba(0, 0, 0, 0.07);
//   margin: 20px 0;
//   border-radius: 12px;
//   padding: 20px 30px;
// }
.detail {
  font-size: 28px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: var(--tc);
}
// .phone-item,
// .addr-item {
//   font-size: 24px;
//   flex: 1;
//   width: 100%;
//   font-weight: 400;
//   font-size: 28px;
//   font-family: PingFangSC-Regular, PingFang SC;
//   font-weight: 400;
//   color: #999999;
// }
// .ellipis {
//   display: inline-block; // 因为只有块级元素才能设置宽度
//   width: 390px; // 一定要设置宽度
//   overflow: hidden;
//   text-overflow: ellipsis; // 设置此项，显示...
//   white-space: nowrap;
// }
</style>
